module.exports = __webpack_public_path__ + "img/xlsx.e048a491.png";